<template>
  <div>
    <div v-if="alarmData.eventType === 'KEYWORD_COUNT'">
      <w-alarm-event-count-setting ref="eventCountSetting"
        @increaseActiveStep="increaseActiveStep"
        @deleteEventRow="deleteEventRow"
        :eventlevelSetting="eventlevelSetting"
        :eventlevelData="eventlevelData"
        :alarmData="alarmData"
        :isAdd="isAdd">
      </w-alarm-event-count-setting>
    </div>
    <div v-else-if="alarmData.eventType === 'ML_PATTERN'">
      <w-alarm-pattern-setting ref="patternSetting"
      @increaseActiveStep="increaseActiveStep"
      @deleteEventRow="deleteEventRow"
      :eventlevelSetting="eventlevelSetting"
      :eventlevelData="eventlevelData"
      :alarmData="alarmData"
      :isAdd="isAdd">
      </w-alarm-pattern-setting>
    </div>
    <div v-else-if="alarmData.eventType === 'UNKNOWN_PATTERN'">
      <w-alarm-unknown-pattern-setting ref="unknownPatternSetting"
        @increaseActiveStep="increaseActiveStep"
        @deleteEventRow="deleteEventRow"
        :eventlevelSetting="eventlevelSetting"
        :eventlevelData="eventlevelData"
        :alarmData="alarmData"
        :isAdd="isAdd">
      </w-alarm-unknown-pattern-setting>
    </div>
    <div v-else-if="alarmData.eventType ==='BASELINE'">
      <w-alarm-base-line-setting ref="baselineSetting"
        @increaseActiveStep="increaseActiveStep"
        @deleteEventRow="deleteEventRow"
        :eventlevelSetting="eventlevelSetting"
        :eventlevelData="eventlevelData"
        :alarmData="alarmData"
        :isAdd="isAdd">
      </w-alarm-base-line-setting>
    </div>
    <div v-else>
      <w-alarm-store-setting ref="storeSetting"
        @increaseActiveStep="increaseActiveStep"
        @deleteEventRow="deleteEventRow"
        :eventlevelSetting="eventlevelSetting"
        :eventlevelData="eventlevelData"
        :alarmData="alarmData"
        :isAdd="isAdd">
      </w-alarm-store-setting>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isNil } from 'lodash';
import WAlarmEventCountSetting from './AlarmEventCountSetting';
import WAlarmBaseLineSetting from './AlarmBaseLineSetting';
import WAlarmStoreSetting from './AlarmStoreSetting';
import WAlarmUnknownPatternSetting from './AlarmUnknownPatternSetting';
import WAlarmPatternSetting from './AlarmPatternSetting';

export default {
  name: 'WAlarmTypeView',
  data() {
    return {
      deleteEventList: [],
      eventlevelData: [],
    };
  },
  props: {
    eventlevelSetting: {
      type: Array,
    },
    alarmData: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
  },
  components: {
    WAlarmEventCountSetting,
    WAlarmBaseLineSetting,
    WAlarmStoreSetting,
    WAlarmUnknownPatternSetting,
    WAlarmPatternSetting,
  },
  methods: {
    /**
     * 알람 타입 설정 데이터 로드 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      if (this.isAdd) {
        this.eventlevelData = [];
      } else {
        this.alarmData.originEventSet = cloneDeep(this.alarmData.eventSet);
        this.eventlevelData = cloneDeep(this.alarmData.eventSet);
      }
      const alarmType = this.getAlarmType();
      this.deleteEventList = [];
      this.$refs[`${alarmType}`].loadData();
    },
    /**
     * 2번째 스탭에서 다음 클릭 시 이벤트 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    nextStep() {
      const alarmType = this.getAlarmType();
      this.$refs[`${alarmType}`].checkValidation();
      this.alarmData.eventSet = this.eventlevelData;
    },
    getAlarmType() {
      switch (this.alarmData.eventType) {
        case 'KEYWORD_COUNT':
          return 'eventCountSetting';
        case 'ML_PATTERN':
          return 'patternSetting';
        case 'UNKNOWN_PATTERN':
          return 'unknownPatternSetting';
        case 'BASELINE':
          return 'baselineSetting';
        default:
          return 'storeSetting';
      }
    },
    increaseActiveStep() {
      this.$emit('increaseActiveStep');
    },
    /**
     * 설정된 이벤트 제거
     * @author leesy918
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteEventRow(scope, index) {
      this.eventlevelData.splice(index, 1);
      if (!isNil(scope.row.eventId)) {
        this.deleteEventList.push(scope.row);
      }
    },
    getDeleteEventList() {
      return this.deleteEventList;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmTypeView.vue